import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { RoleActions } from './roles.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { RoleService } from '@core/services/role.service';
import { AuthenticationService } from '@core/services/auth.service';

@Injectable()
export class RoleEffects {
  private actions$ = inject(Actions);
  private roleService = inject(RoleService);
  private authService = inject(AuthenticationService);
  private translateService = inject(TranslateService);
  getRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleActions.loadRoles),
      mergeMap(() =>
        this.roleService.getRoles().pipe(
          map((roles) =>
            roles.success
              ? RoleActions.loadRolesSuccess(roles)
              : RoleActions.loadRolesFailure(roles)
          ),
          catchError((error) =>
            of(
              RoleActions.loadRolesFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  addRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleActions.addEditRole),
      mergeMap((data) =>
        this.roleService.addRole(data.role).pipe(
          map((role) => {
            if (role.success) {
              return data.role.id
                ? RoleActions.updateRoleSuccess(role)
                : RoleActions.addRoleSuccess(role);
            } else return RoleActions.addRoleFailure(role);
          }),
          catchError((error) =>
            of(
              RoleActions.addRoleFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  deleteRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleActions.deleteRole),
      mergeMap((data) =>
        this.roleService.deleteRole(data.id).pipe(
          map((response) =>
            response.success
              ? RoleActions.deleteRoleSuccess({
                  ...response,
                  id: data.id,
                })
              : RoleActions.deleteRoleFailure(response)
          ),
          catchError((error) =>
            of(
              RoleActions.deleteRoleFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );
}
